// extracted by mini-css-extract-plugin
export default {"activityBanner":"index_activityBanner_KZtbo","activityBannerImg":"index_activityBannerImg_-PwCP"};